<template>
    <fragment>
        <InsideHeader title="Pricing" :bredcrumb="breadcrumb" />
        <Pricing />
    </fragment>
</template>

<script>
import Pricing from '@/components/Pricing'
import InsideHeader from "@/components/InsideHeader.vue";


export default {
    components: {
        Pricing, InsideHeader
    },
    data(){
        return {
            breadcrumb: [
                {title: 'Home', path:'/'},
                {title: 'Pricing', path:'#'}
            ], 
            pricingData: [],
            filePath: '',
            limit: 6,
            pageData: []
        }
    }    
}
</script>